__webpack_require__.p = "/open-pay/";